import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
  padding: 4rem;
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  max-width: 1400px;
  width: 100%;
  align-items: center;
`;

const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const CharacterIllustration = styled(motion.div)`
  font-size: 12rem;
  text-align: center;
  filter: drop-shadow(0 10px 20px rgba(0,0,0,0.1));
`;

const Name = styled(motion.h2)`
  font-size: 3rem;
  color: #042E4B;
  font-weight: 700;
  margin: 0;
`;

const RightSide = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
`;

const IconRow = styled(motion.div)`
  display: flex;
  align-items: center;
  gap: 2rem;
  background: white;
  padding: 2rem;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  border-left: 5px solid #EF443C;
`;

const IconCircle = styled.div`
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #042E4B, #0A4A6F);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.5rem;
  flex-shrink: 0;
`;

const IconText = styled.span`
  font-size: 1.5rem;
  color: #042E4B;
  font-weight: 500;
`;

const DisconnectionVisual = styled(motion.div)`
  display: flex;
  justify-content: space-around;
  margin-top: 2rem;
  position: relative;
`;

const DashedLine = styled.div`
  position: absolute;
  top: 50%;
  left: 10%;
  right: 10%;
  height: 2px;
  border-top: 3px dashed #EF443C;
  opacity: 0.5;
  z-index: 0;
`;

const MiniIcon = styled.div`
  font-size: 3rem;
  background: white;
  padding: 1rem;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  position: relative;
  z-index: 1;
`;

const Summary = styled(motion.div)`
  background: #EF443C;
  color: white;
  padding: 2rem;
  border-radius: 16px;
  font-size: 1.6rem;
  text-align: center;
  font-weight: 600;
  box-shadow: 0 8px 24px rgba(239, 68, 60, 0.3);
`;

const Slide2Persona: React.FC = () => {
  return (
    <Container>
      <Content>
        <LeftSide>
          <CharacterIllustration
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.3 }}
          >
            🤔
          </CharacterIllustration>
          <Name
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.3, delay: 0.1 }}
          >
            Conheça o Tiago
          </Name>
          <DisconnectionVisual
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.4, delay: 0.2 }}
          >
            <DashedLine />
            <MiniIcon>🏢</MiniIcon>
            <MiniIcon>📊</MiniIcon>
            <MiniIcon>👥</MiniIcon>
            <MiniIcon>💼</MiniIcon>
          </DisconnectionVisual>
        </LeftSide>

        <RightSide>
          <IconRow
            initial={{ x: 50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.3, delay: 0.15 }}
          >
            <IconCircle>👔</IconCircle>
            <IconText>Empresário de Pequena Empresa</IconText>
          </IconRow>

          <IconRow
            initial={{ x: 50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.3, delay: 0.25 }}
          >
            <IconCircle>📋</IconCircle>
            <IconText>Múltiplos Departamentos</IconText>
          </IconRow>

          <IconRow
            initial={{ x: 50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.3, delay: 0.35 }}
          >
            <IconCircle>🔌</IconCircle>
            <IconText>Ações Desconectadas</IconText>
          </IconRow>

          <Summary
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.3, delay: 0.45 }}
          >
            Dificuldade em alinhar estratégia com execução
          </Summary>
        </RightSide>
      </Content>
    </Container>
  );
};

export default Slide2Persona;
